import { render, staticRenderFns } from "./POrderGridRow.vue?vue&type=template&id=a4463228&scoped=true"
import script from "./POrderGridRow.vue?vue&type=script&lang=js"
export * from "./POrderGridRow.vue?vue&type=script&lang=js"
import style0 from "./POrderGridRow.vue?vue&type=style&index=0&id=a4463228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4463228",
  null
  
)

export default component.exports